import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import PlantCheeseProduct from 'models/PlantCheeseProduct'
import PlantCheeseNutrition from './PlantCheeseNutrition'
import PlantCheesePackage from './PlantCheesePackage'

const productOptions = {
  nutritionInfo: <PlantCheeseNutrition />,
  packagingInfo: <PlantCheesePackage />,
  productTitle: 'Brand Specific Plant-Based Cheese Alternatives',
  model: PlantCheeseProduct,
  validCategories: ['00'],
  validSubCategories: ['002'],
}

const PlantCheese = () => <ProductForm product={productOptions} />

export default PlantCheese
